export default __webpack_public_path__ + "static/media/logo-jolof-digital.ce451184.svg";